import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-locize-backend';
import { LOCIZE_PROJECT_ID, LOCIZE_API_KEY, LOCIZE_VERSION } from 'Config';

export const locizeNS = {
  COMMON: 'common',
  ACCOUNT: 'account',
  AUTH: 'auth',
  DG: 'dg',
  PY: 'py',
  DASHBOARD: 'dashboard',
  VALIDATIONS: 'validations',
  RESULT: 'result',
  FILING: 'filing',
  MODALS: 'modals',
  MGM: 'mgm',
  PLANS: 'plans',
  ERROR: 'error',
};

const locizeOptions = {
  projectId: LOCIZE_PROJECT_ID ?? '',
  apiKey: LOCIZE_API_KEY,
  referenceLng: 'es',
  version: LOCIZE_VERSION,
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'es',
    ns: [...Object.values(locizeNS)],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    backend: locizeOptions,
    locizeLastUsed: locizeOptions,
    react: {
      bindI18n: 'languageChanged editorSaved',
      useSuspense: true,
    },
  });

export const translate = (key: string, scope?: string, context?: string): string =>
  i18n.t(`${scope}:${key}`, { context });

export default i18n;
